import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8b1c9eec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8b1c9eec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c9eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b1c9eec')) {
      api.createRecord('8b1c9eec', component.options)
    } else {
      api.reload('8b1c9eec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8b1c9eec&scoped=true", function () {
      api.rerender('8b1c9eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/modifyManage/index.vue"
export default component.exports